export default function SettingSlider({ label, tooltip, value, min, max, step, onChange }) {
    return (
        <div className="mb-5">
            {/* 🔹 Label */}
            <label className="font-medium flex items-center gap-2 text-gray-700 mb-1">
                {label}
                {tooltip && (
                    <span
                        title={tooltip}
                        className="text-[#8B5CF6] text-xs cursor-pointer hover:text-[#E91E63] transition"
                    >
                        ℹ️
                    </span>
                )}
            </label>

            {/* 🔹 Slider */}
            <div className="flex items-center gap-3">
                <input
                    type="range"
                    className="w-full appearance-none h-2 rounded-full outline-none cursor-pointer 
          bg-gradient-to-r from-[#3B82F6]/40 via-[#8B5CF6]/40 to-[#E91E63]/40
          accent-[#8B5CF6] transition-all duration-300"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={(e) => onChange(parseFloat(e.target.value))}
                />

                {/* 🔹 Value Box */}
                <span
                    className="w-12 text-center text-sm font-medium text-[#6D28D9] bg-white/70 backdrop-blur-sm 
          border border-[#e3e8f7] rounded-lg py-0.5 shadow-sm select-none"
                >
                    {value}
                </span>
            </div>
        </div>
    );
}
